module.exports = __webpack_public_path__ + "static/10-bba4110187ea966f552da2830769c44c.jpg";